import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  Chip,
  IconButton,
  Tooltip,
  Stack,
  Typography,
  Box,
} from '@mui/material';
import {
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
  GeneralTableBox,
} from '../../../../../common/components';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import QrCodeIcon from '@mui/icons-material/QrCode';
import DeleteIcon from '@mui/icons-material/Delete';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { formatCurrency, formatNumber } from '../../utils/formatters';
import { formatDate, formatDateTime, formatInvoiceNumber } from '../../../../../utils/formatUtils';

const PaymentsTable = ({
  rows,
  onPrint,
  onMarkPaid,
  onDelete,
  onGenerateQr,
  onInvoice,
  onPrintInvoice,
}) => {
  const colSpan = 7;
  return (
    <GeneralTableBox>
      <Table size="small">
        <TableHead>
          <TableRow>
            <HeadTableCell>Fecha</HeadTableCell>
            <HeadTableCell>Cuotas diferidas</HeadTableCell>
            <HeadTableCell>Cuota pura</HeadTableCell>
            <HeadTableCell>Total</HeadTableCell>
            <HeadTableCell>Pagado</HeadTableCell>
            <HeadTableCell>Facturado</HeadTableCell>
            <HeadTableCell>Acciones</HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!rows || rows.length === 0 ? (
            <NoDataSkeleton colSpan={colSpan} message="Sin registros" />
          ) : (
            rows.map((row) => (
              <TableRow key={row.uuid}>
                <RowTableCell>{formatDate(row.paid_at || row.created_at)}</RowTableCell>
                <RowTableCell>
                  {row.installments_to_pay ? formatNumber(row.installments_to_pay) : '-'}
                </RowTableCell>
                <RowTableCell>
                  {row.cuota_pura_snapshot ? formatNumber(row.cuota_pura_snapshot) : '-'}
                </RowTableCell>
                <RowTableCell>{formatCurrency(row.amount)}</RowTableCell>
                <RowTableCell>
                  {row.paid_at ? (
                    <Tooltip
                      title={
                        <Typography variant="caption">
                          {formatDateTime(row.paid_at, {
                            options: { dateStyle: 'short', timeStyle: 'medium' },
                            fallback: '-',
                          })}
                        </Typography>
                      }
                    >
                      <span>{formatDate(row.paid_at)}</span>
                    </Tooltip>
                  ) : (
                    <Chip label="No" size="small" />
                  )}
                </RowTableCell>
                <RowTableCell>
                  {row.invoice_date ? (
                    <Tooltip
                      title={
                        <Box>
                          <Typography variant="caption">
                            {formatDateTime(row.invoice_date, {
                              options: { dateStyle: 'short', timeStyle: 'medium' },
                              fallback: '-',
                            })}
                          </Typography>
                          <Typography variant="caption" display="block">
                            Factura:{' '}
                            {formatInvoiceNumber(
                              'B',
                              row.invoice_sale_point_number,
                              row.invoice_afip_number || row.invoice_receipt_number
                            )}
                          </Typography>
                          {row.invoice_cae && (
                            <Typography variant="caption" display="block">
                              CAE: {row.invoice_cae}
                            </Typography>
                          )}
                        </Box>
                      }
                    >
                      <span>{formatDate(row.invoice_date)}</span>
                    </Tooltip>
                  ) : (
                    <Chip label="No" size="small" color="default" />
                  )}
                </RowTableCell>
                <RowTableCell>
                  <Stack direction="row" spacing={1} justifyContent="center">
                    <Tooltip title={row.paid_at ? 'Pago ya cobrado' : 'Marcar pagado'}>
                      <span>
                        <IconButton
                          size="small"
                          onClick={() => onMarkPaid?.(row.uuid)}
                          disabled={Boolean(row.paid_at)}
                        >
                          <DoneAllIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip title="Generar QR">
                      <span>
                        <IconButton size="small" onClick={() => onGenerateQr?.(row.uuid)}>
                          <QrCodeIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip title={row.has_invoice ? 'Pago ya facturado' : 'Facturar pago'}>
                      <span>
                        <IconButton
                          size="small"
                          onClick={() => onInvoice?.(row.uuid)}
                          disabled={!row.paid_at || row.has_invoice}
                        >
                          <ReceiptLongIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip title="Imprimir diferimento PDF">
                      <span>
                        <IconButton size="small" onClick={() => onPrint?.(row.uuid)}>
                          <PictureAsPdfIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip title="Imprimir factura PDF">
                      <span>
                        <IconButton
                          size="small"
                          onClick={() => onPrintInvoice?.(row.invoice_uuid)}
                          disabled={!row.invoice_uuid}
                        >
                          <ReceiptIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip
                      title={row.paid_at ? 'No se puede eliminar un pago cobrado' : 'Eliminar'}
                    >
                      <span>
                        <IconButton
                          size="small"
                          onClick={() => onDelete?.(row.uuid)}
                          disabled={Boolean(row.paid_at)}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </Stack>
                </RowTableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default PaymentsTable;
